export const ROUTES = {
    HOME: '/',
    INTRODUCTION: '/introduction',
    PROFILE: '/profile',
    TOPUP: '/topup',
    BUY_ESIM: '/buy-esim',
    SOMETHING_WENT_WRONG: '/something_went_wrong'
};
